import {
  ColumnMeta,
  FilterResultMethod,
  formatScreenerCellValue,
  isScreenerPercentageColumn,
  mapValueTypeToFormatter,
} from '@api';
import { WithNAFallback } from '@design/components/table';
import { getPriceStatus, PriceStatus, Status } from '@helpers';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import { priceChangeColors } from '@terminal/utils/common/utils';
import { ReactNode } from 'react';

import { ColumnMetaWithKey } from '../results/screener-table-utils';
import styles from './ScreenerCell.module.scss';

interface ScreenerCellProps {
  value: FilterResultMethod;
  columnMeta: ColumnMetaWithKey | ColumnMeta;
  isDisabled?: boolean;
  customTooltip?: ReactNode;
}

export const ScreenerCell = ({
  value,
  columnMeta,
  isDisabled,
  customTooltip,
}: ScreenerCellProps) => {
  const unit = value.units ?? '';
  const formatter = mapValueTypeToFormatter[columnMeta.value_type || 'integer'];
  const status = columnMeta.directional
    ? getPriceStatus(value.value)
    : PriceStatus.Default;
  const tooltipValue = customTooltip ?? value.tooltip;

  const isPercentage = isScreenerPercentageColumn(columnMeta.name);

  const color =
    priceChangeColors[isDisabled ? Status.Disabled : status] ?? undefined;

  return (
    <TooltipContainer
      className={styles.styledTooltip}
      disabled={!tooltipValue}
      inPortal
      label={tooltipValue}
      placement="top-end"
    >
      <span aria-haspopup={!!tooltipValue}>
        <WithNAFallback
          value={
            value.value !== undefined && (
              <div style={{ color }}>
                {isPercentage
                  ? formatScreenerCellValue(value, columnMeta)
                  : formatter(value.value)}
                {!isPercentage && unit && (
                  <span className={styles.unit}>{unit}</span>
                )}
              </div>
            )
          }
        />
      </span>
    </TooltipContainer>
  );
};
